// home/MainContent.jsx
import FeaturedContent from './FeaturedContent';

function MainContent() {
  return (
    <div className="space-y-6">
      <FeaturedContent />
      {/* Add more: latest posts, predictions, etc. */}
    </div>
  );
}

export default MainContent;